import { REFERRAL_ACTIONS } from '../actions/actionTypes';
import { getShouldSourceReferralsFromReferralService } from '../posthog';

// Matches the monolith `admin/referral` shape — the flag defaults off, so
// this is the shape `fetchReferrals` dispatches on first render before any
// flag has loaded.
const defaultState = {
  referrals: [],
  totalReferrals: 0,
  searchParams: {
    referralPage: 1,
    payFilter: '',
    referrerType: '',
    searchText: '',
  },
};

// eslint-disable-next-line default-param-last
export default (state = defaultState, action) => {
  switch (action.type) {
    case REFERRAL_ACTIONS.GET_REFERRAL_REQUEST:
      return {
        ...state,
        searchParams: action.payload,
        referrals: [],
      };
    case REFERRAL_ACTIONS.GET_REFERRAL_SUCCESS:
      return {
        ...state,
        referrals: action.payload.data,
        totalReferrals: action.payload.total,
        // Which backend actually produced these rows — kept alongside them
        // so a UI decision about how to render a row never has to trust
        // "whatever the flag currently says", which can already have moved
        // on to the next fetch by the time this one lands.
        source: action.payload.source,
      };
    case REFERRAL_ACTIONS.GET_REFERRAL_FAILURE:
      // Only the referral-service path clears the table on failure (it can
      // fail independently of the monolith engine that serves everything
      // else on this reducer's actions). The pre-PR monolith reducer had no
      // FAILURE case at all, so flag-off falls through to `default` and
      // leaves the previous list up, unchanged.
      if (!getShouldSourceReferralsFromReferralService()) {
        return state;
      }
      // Don't leave the previous total beside an emptied table.
      return {
        ...state,
        referrals: [],
        totalReferrals: 0,
      };
    case REFERRAL_ACTIONS.CANCEL_REFERRAL_SUCCESS: {
      const useReferralService = getShouldSourceReferralsFromReferralService();
      const newReferrals = state.referrals.map((r) => {
        if (useReferralService) {
          // The monolith response is keyed by the recipient it cancelled,
          // which is the row's `migratedFrom`, not referral-service's own
          // `id`. The monolith response is the authority until
          // referral-service catches up (GOTU-7245).
          if (r.migratedFrom === action.payload?.id) {
            return {
              ...r,
              isCancelled: action.payload.isCancelled,
              cancelledAt: action.payload.cancelledAt,
            };
          }
          return r;
        }
        if (r.id === action.payload?.id) {
          return {
            ...r,
            ...action.payload,
          };
        }
        return r;
      });
      return {
        ...state,
        referrals: newReferrals,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
